import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

import paypalLogo from 'src/assets/payment/paypal.png';

export const PayWithCreditCardOrPaypalText: React.FC = () => {
	return (
		<div className="flex justify-center text-center">
			<Text className="text-typography-secondary">
				<TranslateHtml
					value="corgi.membership.ask.pay_with"
					replacements={{
						paypalImageElement: (
							<Image alt="paypal" className="ml-1.5 inline aspect-auto h-6 w-auto" src={paypalLogo} />
						),
					}}
				/>
			</Text>
		</div>
	);
};
